import { FC } from 'react';
import Icon from 'components/icon';
import { setFiltersOpen } from 'store/actions/filters';
import { Dispatch } from 'redux';
import { RootState } from 'store/types';
import { connect } from 'react-redux';
import './filters.scss';

interface DispatchProps {
  setFiltersOpen: (isOpen: boolean) => void;
};

interface OwnProps {};

type FiltersProps = DispatchProps & OwnProps;

const Filters: FC<FiltersProps> = ({ setFiltersOpen }: FiltersProps) => {
  return (
    <div className="app-filters-wrap">
      <div className="app-filters">
        <div className="filters-header">
          <h3>Filters</h3>
          <div 
            className="filters-close"
            onClick={() => setFiltersOpen(false)}
          >
            <Icon name="close" />
          </div>
        </div>
        <div className="filters-content" id="filters-content" />
      </div>
    </div>
  )
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setFiltersOpen: (isOpen: boolean) => dispatch(setFiltersOpen(isOpen))
});

export default connect<{}, DispatchProps, OwnProps, RootState>(
  null,
  mapDispatchToProps
)(Filters);
